import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=723f5030&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCard.vue?vue&type=style&index=0&id=723f5030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f5030",
  null
  
)

export default component.exports